<template>
  <section class="leftBody">
        <!-- <Menu defaultActive="2" className="el-menu-vertical-demo" onOpen={this.onOpen.bind(this)} onClose={this.onClose.bind(this)}>
          <Menu.SubMenu index="1" title={<span><i className="el-icon-message"></i>导航一</span>}>
            <Menu.ItemGroup title="分组一">
              <Menu.Item index="1-1">选项1</Menu.Item>
              <Menu.Item index="1-2">选项2</Menu.Item>
            </Menu.ItemGroup>
            <Menu.ItemGroup title="分组2">
              <Menu.Item index="1-3">选项3</Menu.Item>
            </Menu.ItemGroup>
          </Menu.SubMenu>
          <Menu.Item index="2"><i className="el-icon-menu"></i>导航二</Menu.Item>
          <Menu.Item index="3"><i className="el-icon-setting"></i>导航三</Menu.Item>
        </Menu>    -->
        <ul class="list-group">
                        <li class="list-group-item"><span>购物网站</span></li>
                        <li class="list-group-item"><span>产品推广</span></li>
                        <li class="list-group-item"><span>物联互通</span></li>
                        <li class="list-group-item"><span>智能家庭</span></li>
                        <li class="list-group-item"><span>摄影摄像</span></li>
                        <li class="list-group-item"><span>旅行户外</span></li>
                        <li class="list-group-item"><span>亲子育儿</span></li>
                    </ul>   
  </section>
</template>

<script>
export default {
 name: 'leftBody',
  data() {
    return {

    }
  },
  components: {},
  watch: {},
  mounted() {},
  methods: {
onOpen() {

},
onClose() {

}}
}
</script>

<style scoped>
.list-group-item {
    position: relative;
    display: block;
    padding: 0.75rem 1.25rem;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,.125);
}
.list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
}

ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}
</style>
